import React,{useEffect, useState, useRef} from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import appbanner from '../img/applicationbanner.jpg';
import Table from 'react-bootstrap/Table';
import GenInstruction from './GenInstruction';
import Registration from './Registration';
import { Row, Col, Button } from 'react-bootstrap';
import { ArrowRight } from 'lucide-react';
import Carousel from 'react-bootstrap/Carousel';
import schoolOpening from '../assets/staffOpenPosition.jpg';
import RegistrationForm from './RegistrationForm';
import Payment from './Payment';
import PrintApplication from './PrintApplication';
import PrintView from './PrintView';
import PrintViewNew from './PrintViewNew';
import axios from 'axios';
import Preloader from '../components/Preloader/Preloader';
import JobBannerCreator from './JobBannerCreator';
import NewBulletin from '../pages/FlashNews/NewsBulletin';
import ApplicationStatusChecker from '../paymentGateway/ApplicationStatusChecker';

const config = require('../config.json');

export default function Application() {
  const [acknowledged, setAcknowledged] = React.useState(false);
  const [activeKey, setActiveKey] = React.useState('instruction');
  const [dispMsg, setDispMsg] = React.useState('');
  const [loaded, setLoaded] = useState(true);
  const [openJobs, setOpenJobs] = useState([]); 
  const applicationformRef = useRef(null);
  const formRef = useRef(null);
  const [selectedJob, setSelectedJob] = useState(null);

    useEffect(() => {
      fetchJobDetails();
      window.scrollTo(0, 0);
    return () => {
      console.log('Application unmounted');
    };
  }, []);

  const fetchJobDetails = async () => {
        try{
            setLoaded(false);
           // const { idToken } = (await fetchAuthSession()).tokens ?? {};
            const clientID='MDUEDN';
            const searchValue = 'Active';
            const searchTopic = 'PositionStatus';
            await axios.get(`${config.api.invokeURL}/school/jobs?fetchKey=${searchValue}&fetchOption=${searchTopic}&clientID=${clientID}`, {
            headers: {
             // Authorization: idToken,
              'x-api-key':config.api.key
            }
          }).then(async(response) => {
           console.log("response : ", response.data);
            if(response.data.length>0)
            {
                setOpenJobs(response.data);
              setLoaded(true);
            }
            //enqueueSnackbar(response.data.length + " - Staff's records found!",{variant:'success'}); 
            setLoaded(true);
        }).catch((error)=>{
          //enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
        setLoaded(true);
      })
    
        }catch(error){
          //enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
        setLoaded(true);
        }
      }

  const handleAcknowledge = (event) => {
    event.preventDefault();
    setAcknowledged(true);
    setActiveKey('registration');
    formRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const handleSelect = (key) => {

    //console.log("Key :", key);
    if(key==="registration" && !acknowledged){
      alert("Please read and acknowledge the instructions before proceeding to registration.");
      return;
    }
    if(key === 'printapp'||key === 'payment'){
      //console.log("printapp");  
    setActiveKey(key);
    }else
      if (!acknowledged && key !== 'instruction') {
      return;
    }
    setActiveKey(key);
  };

  const handleRoute = (event, item) => {
    event.preventDefault();
    setSelectedJob(item);
    setAcknowledged(true);
    setActiveKey('registration');
    setTimeout(() => {
      formRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };

  return (
    <div className="container-fluid px-0">
     {/* <img style={{paddingBottom:"2%"}} className='img-fluid w-100' src={appbanner} alt='' /> */}
      <Row id="jobopen" style={{paddingLeft:'20px'}}>
        <h3 className="pt-3 fs-4 fs-md-3 mb-3 text-center w-100">Current Openings - Aided Post Applications</h3>
        <NewBulletin />
        {openJobs.length && <JobBannerCreator openJobs={openJobs} handleRoute={handleRoute} />}
      
          {/*openJobs.length > 0 && openJobs.map((item, index) => 
                <Col key={index} xs={12} sm={6} md={4} lg={3} className="">
                  <p className="jobid-tag">{item.positionApplied} - {item.subject}</p>
                  <img
                    className="img-fluid rounded w-100 jobopen-img"
                    src={`${config.s3.imageUrl}images/jobopenings/${item.jobPostingID}.jpg`}
                    alt={item.jobPostingID}
                    style={{maxHeight:'340px', objectFit:'contain', background:'#f8fafc'}}
                  />
                  <p className="jobid-tag">Job ID - {item.jobPostingID}</p>
                  
               </Col>
              )*/}
            
          
      </Row>
      
      {dispMsg}
      <Row className='p-3 gx-3 gy-4' id="applicationform" ref={applicationformRef} >
          <Col xs={12}>
            <div className="d-flex flex-column  justify-content-center align-items-center  tab-content-responsive" style={{minHeight: '60vh'}}>
              <Tabs
                activeKey={activeKey}
                onSelect={handleSelect}
                id="fill-tab-example"
                className="mb-3 w-100"
                fill
              >
                <Tab eventKey="instruction" title="Instructions">
                  <GenInstruction/>
                  <div className="mt-4 mb-3 text-center">
                    <Button 
                      variant="primary" 
                      size="lg" 
                      className="rounded-pill px-5 py-2.5 shadow-sm fw-bold d-inline-flex align-items-center gap-2"
                      onClick={event => handleAcknowledge(event)}
                    >
                      I Have Read & Acknowledge <ArrowRight size={18} />
                    </Button>
                  </div>
                </Tab>
                <Tab eventKey="payment" title="Payment">
                  <ApplicationStatusChecker dispMsg={dispMsg} setDispMsg={setDispMsg} />
                  <Payment dispMsg={dispMsg} setDispMsg={setDispMsg} />
                </Tab>
                <Tab eventKey="registration" title="Registration" >
                  <div>
                  <RegistrationForm setActiveKey={setActiveKey} dispMsg={dispMsg} setDispMsg={setDispMsg} selectedJob={selectedJob} formRef={formRef}/>
                  </div>
                </Tab>
                
                <Tab eventKey="printapp" title="Print Application">
                  <div style={{textAlign:"left"}}>
                  <PrintViewNew dispMsg={dispMsg} setDispMsg={setDispMsg} openJobs={openJobs} />
                  </div>
                </Tab>
              </Tabs>
            </div>
          </Col>
      </Row>
      <style>{`
        .jobid-tag {
          display: inline-block;
          background: #e3f2fd;
          color: #1565c0;
          border-radius: 999px;
          padding: 0.35em 1.2em;
          font-size: 1rem;
          font-weight: 600;
          margin: 0.5em 0 0.5em 0;
          letter-spacing: 0.5px;
          box-shadow: 0 2px 8px 0 rgba(21,101,192,0.08);
        }
        @media (max-width: 991.98px) {
          .tab-content-responsive {
            padding: 0.5rem !important;
          }
          .fs-4 {
            font-size: 1.2rem !important;
          }
        }
        @media (max-width: 767.98px) {
          .tab-content-responsive {
            padding: 0.25rem !important;
          }
          .fs-4 {
            font-size: 1.1rem !important;
          }
          .img-fluid {
            border-radius: 0 !important;
          }
        }
        @media (max-width: 575.98px) {
          .tab-content-responsive {
            padding: 0 !important;
          }
          .fs-4 {
            font-size: 1rem !important;
          }
          .img-fluid {
            border-radius: 0 !important;
          }
          .mb-4 {
            margin-bottom: 1rem !important;
          }
        }
      `}</style>
    </div>
  )
}